if (window.location.href === "https://angry-pablo.myshopify.com/collections/essentials" ||window.location.href === "https://www.angrypablo.cc/collections/essentials"||window.location.href === "https://www.angrypablo.cc/collections/cycling-socks"||window.location.href === "https://www.angrypablo.cc/collections/cycling-clothing"||window.location.href === "https://www.angrypablo.cc/collections/running-socks"||window.location.href === "https://angry-pablo.myshopify.com/collections/cycling-socks"||window.location.href === "https://angry-pablo.myshopify.com/collections/cycling-clothing"||window.location.href === "https://angry-pablo.myshopify.com/collections/running-socks") {
    // listOfProductHandlesToExclude
  const targetHandles = ["hightopclassicyclingsocks_white",'high-top-classic-cycling-socks-charcoal',"hightopclassiccyclingsocks_sand","high-top-classic-cycling-socks-brown",'running-socks-white','running-socks-black','lifestyle-socks-white'];
   // Function to check and process elements
  function checkElements() {
  const elements = document.querySelectorAll('.embedAppSection');
  console.log('--->elements:',elements);
  if (elements.length > 0) {
    // Elements found - run comparison
    elements.forEach(element => {
      const productHandle = element.getAttribute('data-product-handle');
      if (productHandle && targetHandles.includes(productHandle)) {
        console.log('Match found:', productHandle, element);
        // Your custom logic here
        element.style.display = 'none';//hide the swatch
      }
    });
    return true; // Return true if elements were found
  }
  return false; // Return false if no elements found
  
}
  document.addEventListener("DOMContentLoaded", async function () {    
  console.log('--->inside custom_swatchdisp file');
  console.log("Current page is the exact Essentials collection");

 
  // Wait 800ms before running the check
setTimeout(() => {
checkElements();
  }, 1000); // 800ms delay

  });
}